import { isSet } from '../utils/isSet';
import { Dropdown } from "../classes/Dropdown";

class Filter {
    constructor (domNode) {
        this.domNode = domNode;
        if(this.domNode.classList.contains('is-select')) this.inputFilterElm = this.domNode.querySelector('.post-filter');
        if(this.domNode.classList.contains('is-select')) this.filterSupportsMultiple = this.inputFilterElm.hasAttribute('multiple');
        this.filterCountElm = this.domNode.querySelector('.filter-toggle__count');
        this.init();
    }

    init(){
        if(this.domNode.classList.contains('is-select')){
            this.dropdownApi = new Dropdown(
                this.domNode,
                {}
            );

            this.dropdownItems = [];
            this.dropdownItems = (this.dropdownApi.dropdownItems) ? this.dropdownApi.dropdownItems : [];

            this.itemClickHandlers = [];
            const itemClickHandler = this.onItemClick.bind(this);

            if(isSet(this.dropdownItems)){
                this.dropdownItems.forEach((item) => {
                    item.addEventListener('click', itemClickHandler);
                    if(this.itemClickHandlers) this.itemClickHandlers.push(itemClickHandler);
                });
            }

            window.addEventListener(
                'load', 
                this.onPageLoad
            );

            this.getSelectedValues();
            this.updateDropdownItems();
            this.updateDropdownCount();
        }

        if(this.domNode.classList.contains('is-switch')){
            const itemClickHandler = this.onSwitchClick.bind(this);
            this.switchToggle = this.domNode.querySelector('.filter__toggle');

            if(!isSet(this.switchToggle)) return;

            document.addEventListener('htmx:afterRequest', itemClickHandler);
        }


    }

    onItemClick(e){
        e.stopPropagation();

        const item = e.currentTarget;

        if(!isSet(item)) return;

        const value = item.value;

        if(!isSet(value)) return;

        const isSelected = this.isItemSelected(item);

        if(isSelected && this.filterSupportsMultiple === false) return;
        
        let selectedValues = this.getSelectedValues();

        if(isSelected === false){
            if(this.filterSupportsMultiple){
                selectedValues.push(value);
            } else{
                selectedValues = [value];
            }
            this.selectedValues = selectedValues;
            this.updateSelectedValues();
        } 
        else if(isSelected === true){
            const index = selectedValues.indexOf(value);
            selectedValues.splice(index, 1);
            this.selectedValues = selectedValues;
            this.updateSelectedValues();
        } else return;

        this.updateDropdownItems();
        this.updateDropdownCount();
        this.triggerChangeEvent();
    }

    isItemSelected(item){
        const value = item.value;

        if(!isSet(value)) return;

        const selectedValues = this.getSelectedValues();
        return selectedValues.includes(value);
    }

    getSelectedValues(){
        let useArray = [];
        if(isSet(this.inputFilterElm)){
            useArray = this.inputFilterElm.options
        }

        const selected = Array.from(
            useArray
        ).filter(
            function (option) {
                return option.selected;
            }
        ).map(
            function (option) {
                return option.value;
            }
        );

        this.selectedValues = selected;

        return selected ?? [];
    }

    updateSelectedValues(){
        Array.from(this.inputFilterElm.options).forEach((option) => {
            option.selected = this.selectedValues.includes(option.value);
        });
    }

    updateDropdownItems(){
        this.dropdownItems.forEach((item) =>{
            const itemValue = item.value;
            if(!isSet(itemValue)) return;

            const selectedValue = this.selectedValues.find((selectedValue) => String(selectedValue) === String(itemValue));

            if(selectedValue) {
                item.classList.add('is-selected');
            } else{
                item.classList.remove('is-selected');
            }
        });
    }

    updateDropdownCount(){
        if(!isSet(this.filterCountElm)) return;

        if(this.filterSupportsMultiple){
            if(this.selectedValues.length === 0){
                this.filterCountElm.textContent = herschel_theme_locale_strings.showingall;
            } else{
                this.filterCountElm.textContent = String(this.selectedValues.length) + ' ' + herschel_theme_locale_strings.selected;
            }
        } else{
            this.dropdownItems.forEach((item) =>{
                const itemValue = item.value;
                if(!isSet(itemValue)) return;

                const selectedValue = this.selectedValues.find((selectedValue) => String(selectedValue) === String(itemValue));
                
                if(selectedValue) {
                    this.filterCountElm.textContent = item.textContent;
                }
            });
        }

        
    }

    triggerChangeEvent(){
        this.inputFilterElm.dispatchEvent(new Event('change'));
    }

    onSwitchClick(e){
        const switchToggle = e.explicitOriginalTarget;
        if(!isSet(switchToggle)) return;
        if(!isSet(switchToggle.id)) return;
        if(switchToggle.id !== this.switchToggle.id) return;

        const options = switchToggle.dataset.options;

        const optionsArr = options.split('|');

        const value = switchToggle.value;

        let newValue = value;

        optionsArr.forEach((option) => {
            if(option === value) return;

            newValue = option;
        });

        this.switchToggle.value = newValue;
        const switchToggleLabel = this.switchToggle.querySelector('.filter-toggle__label');
        switchToggleLabel.textContent = newValue;
    }
}

exports.Filter = Filter